import React, { useEffect, useState } from 'react';

const CountDown = (props) => {
    const [counter, setCounter] = React.useState(props.initCount);
    const [min, setMin] = React.useState(0);
    const [sec, setSec] = React.useState(0);

    React.useEffect(() => {
        const timer = counter >= 0 && setInterval(() => countTime(), 1000);
        return () => clearInterval(timer);
    }, [counter]);

    const countTime = () => {
        const minute = Math.floor(counter / 60);
        const second = Math.floor(counter - (minute * 60));
        setMin(minute);
        setSec(second);
        setCounter(counter - 1);
    };

    return (
        <>
            <span>{`${min}:${sec < 10 ? '0' : ''}${sec}`}</span>
        </>
    );
};

export default CountDown;
